import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
  structuredData?: object
}

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image = '/img/hero_services.jpg',
  url = 'https://hwconcrete.com',
  type = 'website',
  structuredData
}: SEOProps) => {
  const fullTitle = `${title} | H&W Concrete - Brevard County Concrete Contractor`
  const fullUrl = url === 'https://hwconcrete.com' ? url : `https://hwconcrete.com${url}`

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`https://hwconcrete.com${image}`} />
      <meta property="og:site_name" content="H&W Concrete" />
      <meta property="og:locale" content="en_US" />
      
      {/* Facebook App ID - Add this if you have a Facebook App */}
      {/* <meta property="fb:app_id" content="YOUR_FACEBOOK_APP_ID" /> */}
      
      {/* Instagram - Instagram uses Open Graph tags, so no additional tags needed */}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  )
}

export default SEO 